fetch('/env.json')
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    window.FETCHED_ENV_DATA = data;
  })
  .finally(() => {
    import('./main');
  });
